// Charge la base commune
import './common.js'

// Styles custom
import './scss/pages/news.scss'

// Scripts librairies
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks'
window.lazySizesConfig = window.lazySizesConfig || {}
window.lazySizesConfig.requireJs = function (modules, cb) {
  window.require(modules, cb)
}

// Location Form
async function getLForm ($f) {
  import(/* webpackChunkName: "locationForm" */ './js/components/locationForm.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Contact Form
async function getCForm ($f) {
  import(/* webpackChunkName: "contactForm" */ './js/components/contactForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Pajination
async function getPajination () {
  import(/* webpackChunkName: "pajination" */ './js/components/pajination.js').then(() => {
    Waypoint.refreshAll()
    // sur changement de page, on se repositionne sur le début de listing
    $('ul.pagination > li > a').off().on('click', function () {
      const h = $('#header').height()
      const p = $(this).parents('.pajinate-nav').height()
      $('html,body').animate({ scrollTop: $('#events-pagination').offset().top - h - p - 10 }, 300)
    })
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // alertes bootstrap
  const $a = $('.alert')
  if ($a.length) {
    $a.waypoint(function () {
      import(/* webpackChunkName: "alertBs" */ './scss/components/alertBs.scss')
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion de la localisation
  const $b = $('form[name="lForm"]')
  if ($b.length) {
    $b.waypoint(function () {
      $b.load()
      getLForm($b)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // formulaire de contact
  const $f = $('form[name="cForm"]')
  if ($f.length) {
    $f.waypoint(function () {
      $f.load()
      getCForm($f)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion des pages
  const $d = $('.pajinate')
  if ($d.length) {
    $d.waypoint(function () {
      getPajination()
      this.destroy()
    }, {
      offset: '100%'
    })
  }
})
